import React, { Component }          from 'react';

import axios                         from 'axios';
import { IndeterminateProgress }     from '../common/IndeterminateProgress';

import "./Login.scss";

class Login extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      email: "",
      password: "",
      errorText: "",
      showErrorText: false,
      isSubmitting: false,
    }
  }

  componentDidMount() {
  }

  onEmailChanged(event) {
    this.setState({email: event.target.value});
  }

  onPasswordChanged(event) {
    this.setState({password: event.target.value});
  }

  isEmailValid() {
    const matched = String(this.state.email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    return matched !== null;
  }

  onLoginClick() {
    if (!this.state.email) {
      this.setState({showErrorText: true, errorText: "Please enter an email address"});
      this.animateLoginButton()
    } else if (!this.isEmailValid()) {
      this.setState({showErrorText: true, errorText: "The email address entered is invalid"});
      this.animateLoginButton()
    } else if (!this.state.password) {
      this.setState({showErrorText: true, errorText: "Please enter a password"});
      this.animateLoginButton()
    } else {
      this.setState({showErrorText: false, isSubmitting: true});
      axios.post("/api/login", {email: this.state.email, password: this.state.password}).then(response => {
        if (response.data["user"] && response.data["user"]["role"]) {
          this.setState({isSubmitting: false, email: "", password: ""});
          this.props.navigateTo("DASHBOARD")
        } else {
          this.setState({isSubmitting: false});
        }
      }).catch(e => {
        this.setState({isSubmitting: false});
      })
    }
  }

  animateLoginButton() {
    this.setState({animateLoginButton: true});
    setTimeout(() => this.setState({animateLoginButton: false}), 500);
  }

  render() {
    return (
      <div className={`login__container ${this.props.currentState === "LOGIN" ? 'show' : ''}`}>
        <div className="mobile-header">
          <div className="mobile-header-title">Screen Test Admin</div>
        </div>
        <div className={`login-content ${this.state.isSubmitting ? 'blur' : ''}`}>
          <div className={`error-text ${this.state.showErrorText ? 'show' : ''}`}>{this.state.errorText}</div>
          <div className="field">
            <div className="title">EMAIL</div>
            <input onChange={this.onEmailChanged.bind(this)} value={this.state.email} type="email"/>
          </div>
          <div className="field">
            <div className="title">PASSWORD</div>
            <input onChange={this.onPasswordChanged.bind(this)} value={this.state.password} type="password"/>
          </div>
          <div className="field">
            <div onClick={this.onLoginClick.bind(this)} className={`action-button ${this.state.animateLoginButton ? 'incorrect-animate' : ''}`}>
              LOGIN
            </div>
            <div onClick={this.props.forgotPassword} className={`forgot-password`}>Forgot Password?</div>
          </div>
        </div>
        <IndeterminateProgress show={this.state.isSubmitting} />
        <div className="dialog-container">
          <div className="dialog-content">
            Incorrect email/password combination
          </div>
        </div>
      </div>
    );
  }
}

export default Login;